<template>
<v-layout row wrap class="target-probes__layout__content" style="white">
  <v-flex lg12 xs12 class="pl-3 pb-0 pt-3" style="border-bottom:2px solid #455A64;background-color:rgba(0,0,0,.02)">
    <h4>Scores</h4>
  </v-flex>
  <v-flex md5 lg6 xs12 style="background:white;">
    <div id="container" style="width:100%;height:550px;padding-top:15px;"></div>
    <div style="width:100%;">
      <table style="margin:0 auto;">
        <tr>
          <td style="background-color:rgba(27, 73, 101, 1);border-radius:5px;width:20px;height:20px;"></td>
          <td class="pl-2"><span>Also in chemicalprobes.org</span></td>
        </tr>
      </table>
    </div>
  </v-flex>
  <v-flex md7 lg6 xs12 class="pa-2">
    <v-layout row wrap align-center>
      <v-flex xs2 class="text-xs-center">
        <button class="prev">
          <v-btn fab dark small class="teal lighten-2">
            <v-icon dark>keyboard_arrow_left</v-icon>
          </v-btn>
        </button>
      </v-flex>
      <v-flex xs8 class="text-xs-center elevation-0 pa-0">
        <v-progress-linear color-front="teal lighten-1" color-back="blue-grey" height=15 v-model="counterPrc" v-if="counter < sorted20.length"></v-progress-linear>
        <div style="width:100;text-align:right" v-if="counter < sorted20.length">{{counter}} / {{sorted20.length}}</div>
        <div class="siema white" v-bind:class="{ withOpacity: !doneloading, withoutOpacity: doneloading }">
          <v-card hover v-for="(m, index) in sorted20" :key="index" flat class="mb-2" style="border:1px solid rgba(0,0,0,.1)">
            <v-card-title class="teal lighten-2 white--text">
              <h3 class="headline mb-0 white--text">{{m.namec}}</h3>
              <v-spacer></v-spacer>
              <v-btn class="teal darken-1 white--text" @click.native="redirectToCompound(m.idc)">
                <v-icon class="white--text">navigate_next</v-icon>SHOW MORE
              </v-btn>
            </v-card-title>

            <v-card-title class="teal lighten-2 white--text" v-if="m['chemical_probes_portal']" style="width:100%;">
              <a style="text-decoration:none;width:100%;" target="_blank" :href="'http://www.chemicalprobes.org/' + m.chemical_probes_portal.name">
                <v-card class="teal darken-1 white--text" row wrap hover align-center style="padding:10px 10px 2px 10px;">
                  <img height="40" src="http://www.chemicalprobes.org/sites/all/themes/zurb_foundation/images/cp-img/chemical-probes-logo@2x.png"></img>
                  <v-flex xs12 style="text-align:center;">
                    <star-rating style="margin:0 auto;width:88px !important;" v-bind:max-rating="4" :increment="0.01" :rating="Math.round(parseFloat(m['chemical_probes_portal']['rating_cell']))" :star-size="20" :show-rating="false" :read-only="true" inactive-color="black" active-color="#ffffff"></star-rating>
                  </v-flex>
                  <v-flex xs12>
                    <span class="white--text">Go to The Chemical Probes Portal page for this compound</span>
                  </v-flex>
                </v-card>
              </a>
            </v-card-title>
            <v-card-text class="pa-0" v-on:click="redirectToCompound(m.idc)">
              <v-layout row wrap align-center>
                <v-flex xs6 class="text-xs-center teal darken-1 white--text pa-3">Compound</v-flex>
                <v-flex xs6 class="text-xs-center teal darken-2 white--text pa-3">
                  Values
                  <v-icon id="radar-tooltip" class="white--text" style="font-size:14px;" dark>info</v-icon>
                  <div id="radar-details" style="display:none;text-align:left;">
                    <table style="text-align:left !important;">
                      <tr><td><span class="body-2">PAINS</span></td></tr>
                      <tr><td>1: The compound is not predicted to be a Pan-Assay Interference Compound.</td></tr>
                      <tr><td>0: The compound is predicted to be a Pan-Assay Interference Compound</td></tr>
                      <tr><td><span class="body-2">CELL POTENCY</span></td></tr>
                      <tr><td>1: The compound is active below 10 uM in at least one cell line.</td></tr>
                      <tr><td>0: The compound is no active below 10 uM in any cell line</td></tr>
                      <tr><td><span class="body-2">SAR</span></td></tr>
                      <tr><td>1: The compound has active analogs</td></tr>
                      <tr><td>0: We do not identify analogs of the compound</td></tr>
                      <tr><td><span class="body-2">INACTIVE ANALOGS</span></td></tr>
                      <tr><td>1: The compound has inactive analogs</td></tr>
                      <tr><td>0: We do not identify inactive analogs of the compound</td></tr>
                    </table>
                    <p>POTENCY AND SELECTIVITY are continues measures of potency and selectivity from 0 (no selectivity) to 1. </p>
                    <p>Please see methods for details.</p>
                  </div>
                </v-flex>
                <v-flex xs11 md10 lg10 class="text-xs-right pa-2">
                </v-flex>
                <v-flex xs1  md2 lg2 class="text-xs-right pa-2" v-tooltip:left="{ html: 'Chemical Tool less tha 10-fold selective' }" v-if="!m['is_selectivity']">
                  <v-icon class="red--text pr-2" style="font-size:35px;">report_problem</v-icon>
                </v-flex>
              </v-layout>
              <v-layout row wrap align-center>
                <v-flex xs6 class="text-xs-center">
                  <div>
                    <img style="width:100%;" class="image-carousel" :src="apiUrl + 'shared/ajax/get_compound_image.php?compound_id=' + m.idc" />
                  </div>
                </v-flex>
                <v-flex xs6 class="text-xs-center">
                  <div class="target-probes__layout__content__spider__layout">
                    <div :id="'spider-' + index" style="height: 160px; width:100%; margin: 0 auto;"></div>
                  </div>
                </v-flex>
              </v-layout>
              <div style="width:100%">
                <table class="card-table">
                  <tr>
                    <td class="carousel-table-title">Global Score</td>
                    <td class="carousel-table-value">{{Math.round(m.global * 100) / 100}}</td>
                  </tr>
                  <tr>
                    <td class="carousel-table-title">Rank</td>
                    <td class="carousel-table-value">{{m.global_rank_text}}</td>
                  </tr>
                  <tr>
                    <td class="carousel-table-title">Molecular Weight</td>
                    <td class="carousel-table-value">{{m.molecular_weight}}</td>
                  </tr>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>

      <v-flex xs2 class="text-xs-center">
        <button class="next">
          <v-btn fab dark small class="teal lighten-2">
            <v-icon dark>keyboard_arrow_right</v-icon>
          </v-btn>
        </button>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex lg12 xs12 style="border-bottom:2px solid #455A64;background-color:rgba(0,0,0,.02)">
    <h4 class="pl-3 pb-0 pt-3">Distribution</h4>
  </v-flex>
  <v-flex xs12 style="background:white;">
    <div id="distribution-chart" class="pt-3" style="width:100%; height:300px;"></div>
  </v-flex>

</v-layout>
</template>

<script>
import 'tippy.js/dist/tippy.css'
import tippy from 'tippy.js'

import Siema from 'siema';
import StarRating from 'vue-star-rating'

var Highcharts = require('highcharts');
require('highcharts/modules/data')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
import highchartsMore from 'highcharts/highcharts-more'

highchartsMore(Highcharts)

export default {
  props: ['sorted20', 'all', 'settings', 'distribution'],
  components: {
    StarRating
  },
  data() {
    return {
      apiUrl: process.env.API_URL,
      mappingValues: {
        'global': 'Global',
        'selectivity': 'Selectivity',
        'target_potency': 'Target Potency',
        'cell_potency': 'Cell Potency',
        'sar': 'SAR',
        'inactive_analogs': 'Inactive Analogs',
        'pains': 'PAINS'
      },
      spiderChart: [],
      selected: null,
      mySiema: null,
      counter: 0,
      counterPrc: 0,
      loadingLocal: false,
      categories1: [],
      categories2: [],
      doneloading: true
    }
  },
  mounted() {

    tippy('#radar-tooltip', {
      html: '#radar-details',
      duration: 1000,
      arrow: true,
      trigger: 'mouseenter'
    })

    let categories = [];
    let values = [];

    let that = this;

    this.sorted20.map(function(m) {
      categories.push(m.namec);
      values.push(m[that.settings.display]);
    })

    this.categories1 = categories;

    this.renderChart(categories, values);
    this.renderCarousel();

    let imgs = document.querySelectorAll(".image-carousel"),
      len = imgs.length;

    [].forEach.call(imgs, function(img) {
      img.addEventListener('load', incrementCounter, false);
    });

    function incrementCounter() {
      that.counter = that.counter + 1;
      that.counterPrc = that.counter * 100 / that.sorted20.length;
    }

    let dTemp = this.distribution;

    let cDis = [],
      vDis = [];

    Object.keys(dTemp).map(function(m, i) {
      cDis.push(m);
      vDis.push(dTemp[m]);
    });

    this.renderDistribution(cDis, vDis);

  },
  watch: {
    counter(newValue) {
      if (newValue < this.sorted20.length) {
        this.doneloading = false;
      } else {
        this.doneloading = true;
      }
    },
    selected(newValue) {

      let that = this;

      that.barChart.series[0].data.map(function(m, i) {
        let point = that.barChart.series[0].data[i];

        if (newValue.namec === m.category) {
          if (newValue['chemical_probes_portal']) {
            point.update({
              color: "rgba(27, 73, 101, 1)"
            })
          } else {
            point.update({
              color: "#4DB6AC"
            })
          }
          that.mySiema.goTo(i);
        } else {
          if (newValue.namec !== that.sorted20[i].namec && that.sorted20[i].namec === m.category) {

            if (that.sorted20[i]['chemical_probes_portal']) {
              point.update({
                color: "rgba(27, 73, 101, 0.3)"
              })
            } else {
              point.update({
                color: "rgba(77, 182, 172, 0.3)"
              })
            }
          }
        }
      })
    },
    settings(newValue, oldValue) {

      let categories = [];
      let values = [];

      let that = this;

      if (that.barChart) {
        that.barChart.destroy();
        that.barChart = null;
        that.mySiema.destroy(true);
        this.sorted20.map(function(m, i) {
          if (that.spiderChart[i] !== undefined) {
            that.spiderChart[i].destroy();
          }
        })
      }

      this.sorted20.map(function(m) {
        categories.push(m.namec);
        values.push(m[that.settings.display]);
      })

      if (oldValue.sort !== newValue.sort) {
        // handle cases for not loading already download images and the same images exaclty on same indexes
        that.counter = that.sorted20.length - that.diffIndex(that.categories1, categories);
        that.counterPrc = that.counter * 100 / that.sorted20.length;
        that.categories1 = categories;
        if (that.counter !== that.sorted20.length) {
          that.doneloading = false;
        }
      }

      this.renderChart(categories, values);

      this.mySiema.init();

      that.barChart.series[0].data.map(function(m, i) {

        let point = that.barChart.series[0].data[i];

        if (!i) {
          if (that.sorted20[i].namec === m.category) {
            if (that.sorted20[i]['chemical_probes_portal']) {
              point.update({
                color: "rgba(27, 73, 101, 1)"
              })
            } else {
              point.update({
                color: "#4DB6AC"
              })
            }
            that.mySiema.goTo(i);
          }
        } else {

          if (that.sorted20[i]['chemical_probes_portal']) {
            point.update({
              color: "rgba(27, 73, 101, 0.3)"
            })
          } else {
            point.update({
              color: "rgba(77, 182, 172, 0.3)"
            })
          }
        }
      })
    },
    distribution(newValue) {

      let that = this;

      that.distributionChart.destroy();

      let dTemp = this.distribution;

      let cDis = [],
        vDis = [];

      Object.keys(dTemp).map(function(m, i) {
        cDis.push(m);
        vDis.push(dTemp[m]);
      });
      this.renderDistribution(cDis, vDis);
    }
  },
  methods: {
    diffIndex(arr1, arr2) {
      let diff = [];

      arr1.map(function(m, i){
        if (m !== arr2[i]) {
           diff.push(i)
        }
      });

      return diff.length
    },
    redirectToCompound(compound) {
      this.$router.push('/' + this.$route.params.id + '/' + compound);
    },
    renderChart(categories, values) {

      let that = this;

      this.barChart = Highcharts.chart('container', {
        chart: {
          type: 'column',
          style: {
            fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
          }
        },
        title: {
          text: 'Top '+ this.sorted20.length +' Rated Chemical Probes<br/> Sort By: <b>' + this.mappingValues[this.settings.sort] + ' Score </b><br/>Display value: <b>' + this.mappingValues[this.settings.display] + ' Score</b>',
          userHTML: true
        },
        xAxis: {
          categories: categories,
          title: {
            text: 'Chemical Probes'
          }
        },
        yAxis: {
          title: {
            text: this.mappingValues[this.settings.display] + ' Score'
          }
        },
        tooltip: {
          pointFormat: "Value: {point.y:.2f}"
        },
        series: [{
          name: 'Score',
          data: values,
          cursor: 'pointer',
          showInLegend: false,
          pointPadding: 0.03,
          groupPadding: 0,
          width: 30,
          point: {
            events: {
              click: function() {
                that.selected = that.sorted20[this.index];
              }
            }
          }
        }]
      });
    },
    renderDistribution(categories, values) {

      let that = this;

      this.distributionChart = Highcharts.chart('distribution-chart', {
        chart: {
          type: 'column',
          style: {
            fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
          }
        },
        title: {
          text: 'Distribution' + '<br/>Display value: <b>' + this.mappingValues[this.settings.display] + ' Score</b>',
          userHTML: true
        },
        xAxis: {
          categories: categories
        },
        yAxis: {
          title: {
            text: 'Frequency'
          }
        },
        tooltip: {
          shared: true,
          formatter: function() {
              return this.x + ': ' + '<b>' + this.y + ' compounds  </b>';
          }
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.5
          }
        },
        series: [{
          color: '#4DB6AC',
          pointPadding: 0,
          groupPadding: 0,
          name: 'Score',
          data: values
        }]
      });
    },
    renderCarousel() {
      let that = this;

      that.mySiema = new Siema({
        onInit: printSlideIndex,
        onChange: printSlideIndex
      });

      document.querySelector('.prev').addEventListener('click', () => that.mySiema.prev());
      document.querySelector('.next').addEventListener('click', () => that.mySiema.next());

      function printSlideIndex() {

        that.selected = that.sorted20[this.currentSlide];

        let s = that.sorted20[this.currentSlide];

        that.spiderChart[this.currenSlide] = Highcharts.chart('spider-' + this.currentSlide, {

          chart: {
            polar: true,
            type: 'line',
            style: {
              fontFamily: "'Avenir', Helvetica, Arial, sans-serif"
            }
          },

          title: {
            text: '',
            x: -80
          },

          pane: {
            size: '70%'
          },

          xAxis: {
            categories: ['PAINS-free', 'Selectivity', 'Target Potency', 'Cell Potency', 'SAR', 'Inactive Analogs'],
            tickmarkPlacement: 'on',
            lineWidth: 0,
            padding: 0,
            labels: {
              style: {
                color: 'rgba(0,0,0,.7)'
              }
            }
          },

          yAxis: {
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            min: 0,
            tickPositioner: function(min, max) {
              return [min, max];
            }
          },

          tooltip: {
            shared: true,
            pointFormat: "Value: {point.y:.2f}"
          },

          legend: {
            align: 'right',
            verticalAlign: 'top',
            y: 70,
            layout: 'vertical'
          },

          series: [{
            name: 'Values',
            showInLegend: false,
            color: '#4DB6AC',
            data: [s.pains, s.selectivity, s.target_potency, s.cell_potency, s.sar, s.is_inactive_analogs],
            pointPlacement: 'on'
          }]
        });
      }
    }
  }
}
</script>
<style scoped>
.target-probes__layout__content {
  margin: 0 0px 10px 0px;
}

.target-probes__layout__content__spider__layout {
  width: 100%;
  text-align: center;
}

.carousel-table-value {
  background: #4DB6AC;
  color: white;
  padding: 10px;
}

.carousel-table-title {
  border-bottom: 1px solid #4DB6AC;
}

.card-table {
  width: 100%;
  border-spacing: 0;
  border: 1px solid #4DB6AC;
}

.withOpacity{
  opacity: 0.5;
}

.withoutOpacity {
  opacity: 1;
}
@media screen and (max-width: 1000px) {
  .card-table tr td {
    font-size: 18px !important;
  }
}

#radar-details table tr td {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// PrbTargetCompounds.vue?107ca48c